import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { gerichteApi } from '../features/gerichte/gerichteConnector';
import { listenApi } from '../features/listen/listenConnector';
import { zutatenApi } from '../features/zutaten/zutatenConnector';

export const store = configureStore({
  reducer: {
    gerichte: gerichteApi.reducer,
    listen: listenApi.reducer,
    zutaten: zutatenApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(gerichteApi.middleware, listenApi.middleware, zutatenApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
